import React from "react";
import { Box } from "@catchoftheday/cg-components";
import { Benefits } from "./Benefits";
import { ContentWrapper } from "./ContentWrapper";
import { Divisions } from "./Divisions";
import { FAQs } from "./FAQs";
import { HeaderBanner } from "./HeaderBanner";
import { HowToTransfer } from "./HowToTransfer";
import { SEO } from "./SEO";
import { TransferReason } from "./TransferReason";
export const MigrationPage = ({ host }) => {
    return (<>
      <SEO host={host}/>
      <Box fontFamily="onePass">
        <HeaderBanner />
        <ContentWrapper>
          <Divisions />
          <Benefits />
          <TransferReason />
          <HowToTransfer />
          <FAQs />
        </ContentWrapper>
      </Box>
    </>);
};
